/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "depot-management",
	data() {
		return {
			depots: [],
			depotHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "City",
					field: "city"
				},
				{
					text: "Province",
					field: "province"
				},
				{
					text: "GPS Coordinates",
					field: "gpsCoordinates"
				},
				{
					text: "PhoneNumber",
					field: "primaryTelephoneNumber"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			provinces: [],
			provincesFilter: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				manageProducts: "manageProducts",
				managePumps: "managePumps",
				manageSupervisors: "manageSupervisors",
                manageAttendants: "manageAttendants"
			},
			depotAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditDepotModal",
				heading: "Add Depot",
				depot:{
					depotId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					street: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					suburb: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					city: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					postalCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					provinceId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					gpsCoordinates: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					latitude:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					longitude: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					primaryPhoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					primaryEmailAddress: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true
				}
			},
			depotMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveDepotModal",
				heading: "Mark Depot As Active/Inactive",
				isActive: true,
				depotId: null
			},
			depotManageProductsModal:{
				showModal: false,
				isSaving: false,
				modalId: "manageDepotProductsModal",
				heading: "Manage Depot Products",
				depotId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				provinceId: 0
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepots() {
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				provinceId: this.filter.provinceId === null ? 0 : this.filter.provinceId
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						for(let i = 0; i < this.depots.length; i++){
							this.depots[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.depots[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
								{
									name: "Manage Products",
									key: this.actionKeys.manageProducts
								},
                                {
                                    name: "Manage Attendants",
                                    key: this.actionKeys.manageAttendants
                                }
							];
						}
						this.depots = dataTableHelper.castFieldValues(this.depots);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProvinces() {
			systemService.getProvinces().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.provinces = successResponse.data.result;
						this.provincesFilter = this.provinces;
						this.provinces = $.map(this.provinces,
							function (obj) {
								obj.id = obj.id || obj.provinceId;
								obj.text = obj.text || obj.description;
								return obj;
							});

						this.provincesFilter.unshift(
							{
								provinceId: 0,
								description: "All",
								countryId: 1
							});
						this.provincesFilter = $.map(this.provincesFilter,
							function (obj) {
								obj.id = obj.id || obj.provinceId;
								obj.text = obj.text || obj.description;
								return obj;
							}
						);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getDepots();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onProvinceFilterSelected(province){
			this.filter.provinceId = province.id;
			console.log("filter", this.filter);
		},
		onAddDepotClick(){
			this.depotAddEditFormModal.heading = "Add Depot";
			this.clearDepotModel();
			this.depotAddEditFormModal.showModal = true;
		},
		onDepotActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.depotAddEditFormModal.showModal = true;
					this.depotAddEditFormModal.heading = "Edit Depot";
					this.depotAddEditFormModal.depot.depotId = actionAndData.data.depotId;
					this.depotAddEditFormModal.depot.name.value = actionAndData.data.name;
					this.depotAddEditFormModal.depot.street.value = actionAndData.data.street;
					this.depotAddEditFormModal.depot.suburb.value = actionAndData.data.suburb;
					this.depotAddEditFormModal.depot.city.value = actionAndData.data.city;
					this.depotAddEditFormModal.depot.postalCode.value = actionAndData.data.postalCode;
					this.depotAddEditFormModal.depot.provinceId.value = actionAndData.data.provinceId;
					this.depotAddEditFormModal.depot.gpsCoordinates.value = actionAndData.data.gpsCoordinates;
					let coordinates = actionAndData.data.gpsCoordinates.split(",");
					this.depotAddEditFormModal.depot.latitude.value = coordinates[0];
					this.depotAddEditFormModal.depot.longitude.value = coordinates[1];
					this.depotAddEditFormModal.depot.primaryPhoneNumber.value = actionAndData.data.primaryTelephoneNumber;
					this.depotAddEditFormModal.depot.primaryEmailAddress.value = actionAndData.data.primaryEmailAddress;
					this.depotAddEditFormModal.depot.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.depotMarkAsActiveInactiveModal.showModal = true;
					this.depotMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.depotMarkAsActiveInactiveModal.heading = "Mark Depot As " + (this.depotMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.name;
					this.depotMarkAsActiveInactiveModal.depotId = actionAndData.data.depotId;
					break;
				case this.actionKeys.manageProducts:
					this.depotManageProductsModal.showModal = true;
					this.depotManageProductsModal.heading = "Manage Products - " + actionAndData.data.name;
					this.depotManageProductsModal.depotId = actionAndData.data.depotId;
					break;
				case this.actionKeys.managePumps:
					this.$router.push("/depots/depotPumpsManagement/" + actionAndData.data.depotId + "/" + actionAndData.data.name);
					break;
				case this.actionKeys.manageSupervisors:
					this.$router.push("/depots/depotSupervisors/" + actionAndData.data.depotId + "/" + actionAndData.data.name);
					break;
                case this.actionKeys.manageAttendants:
                    this.$router.push("/depots/depotAttendants/" + actionAndData.data.depotId + "/" + actionAndData.data.name);
                    break;
			}
		},
		onMarkDepotActiveInactiveSelected(isActive){
			this.depotMarkAsActiveInactiveModal.isActive = isActive;
			console.log("depotMarkAsActiveInactiveModal.isActive", this.depotMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.depotMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				depotId: this.depotMarkAsActiveInactiveModal.depotId,
				isActive: markAsActive
			};
			systemService.markDepotAsActiveOrInactive(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getDepots();
						this.depotMarkAsActiveInactiveModal.showModal = false;
						this.depotMarkAsActiveInactiveModal.isActive = true;
						this.depotMarkAsActiveInactiveModal.depotId = null;
					}
					this.depotMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.depotMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onProvinceSelected(province){
			this.depotAddEditFormModal.depot.provinceId.value = province.id;
			console.log("depotAddEditFormModal.depot.provinceId", this.depotAddEditFormModal.depot.provinceId.value);
		},
		onManageDepotProductsModalOkClicked(){
			this.depotManageProductsModal.showModal = false;
		},
		onAddOrEditDepotModalCloseClick(){
			this.depotAddEditFormModal.showModal = false;
			this.clearDepotModel();
		},
		validateDepotSubmission(){
			let canSave = true;
			if(this.depotAddEditFormModal.depot.latitude.value == null || this.depotAddEditFormModal.depot.latitude.value.trim() == ""){
				this.depotAddEditFormModal.depot.latitude.hasError = true;
				this.depotAddEditFormModal.depot.latitude.errorMessage = "Latitude is required";
				canSave = false;
			}
			if(this.depotAddEditFormModal.depot.longitude.value == null || this.depotAddEditFormModal.depot.longitude.value.trim() == ""){
				this.depotAddEditFormModal.depot.longitude.hasError = true;
				this.depotAddEditFormModal.depot.longitude.errorMessage = "Longitude is required";
				canSave = false;
			}
			if(isNaN(this.depotAddEditFormModal.depot.latitude.value.trim())){
				this.depotAddEditFormModal.depot.latitude.hasError = true;
				this.depotAddEditFormModal.depot.latitude.errorMessage = "Latitude must be a valid number";
				canSave = false;
			}
			if(isNaN(this.depotAddEditFormModal.depot.longitude.value.trim())){
				this.depotAddEditFormModal.depot.longitude.hasError = true;
				this.depotAddEditFormModal.depot.longitude.errorMessage = "Longitude must be a valid number";
				canSave = false;
			}
			if(canSave){
				this.depotAddEditFormModal.depot.latitude.hasError = false;
				this.depotAddEditFormModal.depot.latitude.errorMessage = "";
				this.depotAddEditFormModal.depot.longitude.hasError = false;
				this.depotAddEditFormModal.depot.longitude.errorMessage = "";
				this.saveDepot();
			}
		},
		saveDepot(){
			this.depotAddEditFormModal.isSaving = true;
			let request = {
				depotId: this.depotAddEditFormModal.depot.depotId === null ? 0 : this.depotAddEditFormModal.depot.depotId,
				name: this.depotAddEditFormModal.depot.name.value,
				street: this.depotAddEditFormModal.depot.street.value,
				suburb: this.depotAddEditFormModal.depot.suburb.value,
				city: this.depotAddEditFormModal.depot.city.value,
				postalCode: this.depotAddEditFormModal.depot.postalCode.value,
				provinceId: this.depotAddEditFormModal.depot.provinceId.value === null ? 0 : this.depotAddEditFormModal.depot.provinceId.value,
				gpsCoordinates: this.depotAddEditFormModal.depot.latitude.value + "," + this.depotAddEditFormModal.depot.longitude.value,
				latitude: this.depotAddEditFormModal.depot.latitude.value,
				longitude: this.depotAddEditFormModal.depot.longitude.value,
				primaryTelephoneNumber: this.depotAddEditFormModal.depot.primaryPhoneNumber.value,
				primaryEmailAddress: this.depotAddEditFormModal.depot.primaryEmailAddress.value,
				isActive: this.depotAddEditFormModal.depot.isActive
			};
			systemService.addOrUpdateDepot(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotValidationResponse.valuesAreValid){
							this.getDepots();
							this.depotAddEditFormModal.showModal = false;
							this.clearDepotModel();
						}
						else{
							this.depotAddEditFormModal.depot.provinceId.hasError = successResponse.data.depotValidationResponse.provinceValidationResponse.hasError;
							this.depotAddEditFormModal.depot.provinceId.errorMessage = successResponse.data.depotValidationResponse.provinceValidationResponse.message;

							this.depotAddEditFormModal.depot.name.hasError = successResponse.data.depotValidationResponse.nameValidationResponse.hasError;
							this.depotAddEditFormModal.depot.name.errorMessage = successResponse.data.depotValidationResponse.nameValidationResponse.message;

							this.depotAddEditFormModal.depot.street.hasError = successResponse.data.depotValidationResponse.streetValidationResponse.hasError;
							this.depotAddEditFormModal.depot.street.errorMessage = successResponse.data.depotValidationResponse.streetValidationResponse.message;

							this.depotAddEditFormModal.depot.suburb.hasError = successResponse.data.depotValidationResponse.suburbValidationResponse.hasError;
							this.depotAddEditFormModal.depot.suburb.errorMessage = successResponse.data.depotValidationResponse.suburbValidationResponse.message;

							this.depotAddEditFormModal.depot.city.hasError = successResponse.data.depotValidationResponse.cityValidationResponse.hasError;
							this.depotAddEditFormModal.depot.city.errorMessage = successResponse.data.depotValidationResponse.cityValidationResponse.message;

							this.depotAddEditFormModal.depot.postalCode.hasError = successResponse.data.depotValidationResponse.postalCodeValidationResponse.hasError;
							this.depotAddEditFormModal.depot.postalCode.errorMessage = successResponse.data.depotValidationResponse.postalCodeValidationResponse.message;

							this.depotAddEditFormModal.depot.primaryPhoneNumber.hasError = successResponse.data.depotValidationResponse.primaryPhoneNumberValidationResponse.hasError;
							this.depotAddEditFormModal.depot.primaryPhoneNumber.errorMessage = successResponse.data.depotValidationResponse.primaryPhoneNumberValidationResponse.message;

							this.depotAddEditFormModal.depot.primaryEmailAddress.hasError = successResponse.data.depotValidationResponse.primaryEmailValidationResponse.hasError;
							this.depotAddEditFormModal.depot.primaryEmailAddress.errorMessage = successResponse.data.depotValidationResponse.primaryEmailValidationResponse.message;

							this.depotAddEditFormModal.depot.longitude.hasError = successResponse.data.depotValidationResponse.longitudeValidationResponse.hasError;
							this.depotAddEditFormModal.depot.longitude.errorMessage = successResponse.data.depotValidationResponse.longitudeValidationResponse.message;
							
							this.depotAddEditFormModal.depot.latitude.hasError = successResponse.data.depotValidationResponse.latitudeValidationResponse.hasError;
							this.depotAddEditFormModal.depot.latitude.errorMessage = successResponse.data.depotValidationResponse.latitudeValidationResponse.message;

						}
					}
					this.depotAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.depotAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditDepotSaveClick(){
			this.saveDepot();
		},
		clearDepotModel(){
			this.depotAddEditFormModal.depot = {
				depotId: null,
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				street: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				suburb: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				city: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				postalCode: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				provinceId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				gpsCoordinates: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				latitude:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				longitude: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				primaryPhoneNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				primaryEmailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Depots");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Depots");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getDepots();
		this.getProvinces();
	}
};